import testimonialsContent from "@/content/testimonials.json";

export const TESTIMONIALS = testimonialsContent.reviews;
